import React from 'react'
import { mount } from 'enzyme'

import { Dropdown } from '../../elements'

describe('PopupMessage', () => { 
  let wrapper, props, instance

  beforeAll(() => {
    props = {
      onChange: () => {
        return 'close'
      },
      options: [
        ['a', 'b']
      ]
    }
    wrapper = mount(<Dropdown {...props} />)
    instance = wrapper.instance()
  })

  describe("#render", () => {
    it("renders", () => {
      expect(wrapper).toBeTruthy()
    })

    it("renders and changes value", () => {
      wrapper.setProps({ value: 'b' })

      expect(wrapper).toBeTruthy()
    })

    it("renders and has same value", () => {
      wrapper.setProps({ value: 'b' })

      expect(wrapper).toBeTruthy()
    })
  })

  describe("#getClasses", () => {
    describe("default", () => {
      it("returns hash", () => {
        const classes = instance.getClasses()
  
        expect(classes).toBeTruthy()
      })
    })

    describe("has no padding", () => {
      it("returns hash", () => {
        wrapper.setProps({ noPadding: true })
        const classes = instance.getClasses()
  
        expect(classes).toBeTruthy()
      })
    })

    describe("has defaultWith", () => {
      it("returns hash", () => {
        wrapper.setProps({ defaultWith: true })
        const classes = instance.getClasses()
  
        expect(classes).toBeTruthy()
      })
    })
  })

  describe("#onCheckSelection", () => {
    it("sets values", () => {
      instance.onCheckSelection({ target: { value: null }})

      expect(instance.state.value).toBeNull()
    })
  })
})
